import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms';

@Component({
  selector: 'sales-portal-input-number',
  templateUrl: './sales-portal-input-number.component.html',
  styleUrls: ['./sales-portal-input-number.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SalesPortalInputNumberComponent),
      multi: true
    }
  ]
})
export class SalesPortalInputNumberComponent implements ControlValueAccessor {
  @Input() min: number = 0;
  @Input() maxFractionDigits: number = 2;
  @Input() minFractionDigits: number = 2;
  @Input() disabled: boolean = false
  @Input() height: string = '30px';


  value: number | undefined;

  onChange: any = () => {
  };
  onTouch: any = () => {
  };

  constructor() {
  }

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onTouch(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle disabling if necessary
  }
}
